<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="章节">-->
<!--                  <el-input  v-model="queryForm.charpterId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="习题">
<!--                  <el-input  v-model="queryForm.exerciseId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择练习题" labelName="exerciseName"
                               labelValue="id" :value="queryForm.exerciseId" :limit='1' size='small' placeholder='请选择练习题'
                               @getValue="getSeachUser" :columns="EDUCLASSCOURSTESTPAPER_code" :searchs="EDUCLASSCOURSTESTPAPER_search" dataListUrl="/edu/exercise/findList" entityBeanName="eduExercise" queryEntityUrl="/edu/exercise/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseCharpterTestpaperList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduCourseCharpterTestpaper"
        >新建</el-button>
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editEduCourseCharpterTestpaper(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduCourseCharpterTestpaper(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduCourseCharpterTestpaperList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduCourseCharpterTestpaperList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduCourseCharpterTestpaperList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="charpterId"-->
<!--        label="章节"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="exerciseId"
        label="习题"
        width="180"
      >
          <template slot-scope="scop">
              {{ scop.row.exercise ? scop.row.exercise.exerciseName : '--' }}
          </template>
      </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="sort"
            label="排序"
            width="180"
        > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
<!--            <div @click="checkEduCourseCharpterTestpaper(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editEduCourseCharpterTestpaper(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteEduCourseCharpterTestpaper(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduCourseCharpterTestpaperStates[eduCourseCharpterTestpaperState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduCourseCharpterTestpaper"
          ref="eduCourseCharpterTestpaperForm"
          :rules="rules"
          label-width="60px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="章节"-->
<!--            prop="charpterId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseCharpterTestpaper.charpterId"-->
<!--              :disabled="eduCourseCharpterTestpaperState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="习题"
            prop="exerciseId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseCharpterTestpaper.exerciseId"-->
<!--              :disabled="eduCourseCharpterTestpaperState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择练习题" labelName="exerciseName" :disabled="eduCourseCharpterTestpaperState == 'check'"
                           labelValue="id" :value="eduCourseCharpterTestpaper.exerciseId" :limit='1' size='small' placeholder='请选择练习题'
                           @getValue="getValueUser" :columns="EDUCLASSCOURSTESTPAPER_code" :searchs="EDUCLASSCOURSTESTPAPER_search" dataListUrl="/edu/exercise/findList" entityBeanName="eduExercise" queryEntityUrl="/edu/exercise/get">
              </GridSelectU>
          </el-form-item>
            <el-form-item
                label="排序"
                prop="sort"
            >
                <el-input-number
                    style="width: 177px"
                    :disabled="eduCourseCharpterTestpaperState == 'check'"
                    v-model="eduCourseCharpterTestpaper.sort"
                    size="small"
                    label=""
                    :min="1"
                    :max="100000"
                    :step="1"
                    :controls="true"
                    controls-position="both"
                >
                </el-input-number>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduCourseCharpterTestpaperState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/gidselect.vue';
import { EDUCLASSCOURSTESTPAPER, EDUCLASSCOURSTESTPAPER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduCourseCharpterTestpaperList();
                    this.getEduCourseCharpterTestpaperList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduCourseCharpterTestpaperList();
                    this.getEduCourseCharpterTestpaperList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     charpterId: '', //章节
                     exerciseId: '', //习题
                },
                EDUCLASSCOURSTESTPAPER_code: EDUCLASSCOURSTESTPAPER,
                EDUCLASSCOURSTESTPAPER_search: EDUCLASSCOURSTESTPAPER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduCourseCharpterTestpaperState: 'add',
                eduCourseCharpterTestpaperStates: {
                    add: '新建章节习题',
                    check: '查看章节习题',
                    edit: '修改章节习题'
                },

                multipleSelection: [],
                eduCourseCharpterTestpaperList: [],
                eduCourseCharpterTestpaper: {
                    id: '', //
                    charpterId: '', //章节
                    exerciseId: '', //习题
                    sort: 1,
                },
                btnLoading: false,

                rules: {
                    charpterId: [{ required: true, message: '章节不能为空', trigger: 'blur' }],
                    exerciseId: [{ required: true, message: '习题不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '章节排序不能为空', trigger: 'blur' }]
                }
            };
        },
        created() {

        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(val){
                this.eduCourseCharpterTestpaper.charpterId = val;
                this.queryForm.charpterId = val;
                this.getEduCourseCharpterTestpaperList();
            },
            getValueUser(value){
                this.eduCourseCharpterTestpaper.exerciseId = value;
            },
            getSeachUser(value){
                this.queryForm.exerciseId = value;
            },
            resetEduCourseCharpterTestpaperList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduCourseCharpterTestpaperList = [];
            },
            resetDialog() {
                this.eduCourseCharpterTestpaperState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      charpterId: this.queryForm.charpterId, //章节
                      exerciseId: '', //习题
                };
                this.getEduCourseCharpterTestpaperList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduCourseCharpterTestpaper = {
                      id: '', //
                      charpterId: this.eduCourseCharpterTestpaper.charpterId, //章节
                      exerciseId: '', //习题
                      sort: 1
                };
            },
            submitForm() {
                if (this.eduCourseCharpterTestpaperState == 'add') {
                    this.$refs.eduCourseCharpterTestpaperForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursecharptertestpaper/add`,{ ...this.eduCourseCharpterTestpaper }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduCourseCharpterTestpaperList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduCourseCharpterTestpaperState == 'edit') {
                    this.$refs.eduCourseCharpterTestpaperForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursecharptertestpaper/edit`,{ ...this.eduCourseCharpterTestpaper }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduCourseCharpterTestpaperList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduCourseCharpterTestpaper() {
                this.showDialog = true;
                this.eduCourseCharpterTestpaperState = 'add';
            },
            checkEduCourseCharpterTestpaper(eduCourseCharpterTestpaperId) {
                console.log(eduCourseCharpterTestpaperId);
                this.currentEduCourseCharpterTestpaperId = eduCourseCharpterTestpaperId;

                this.getEduCourseCharpterTestpaperById();
                this.showDialog = true;
                this.eduCourseCharpterTestpaperState = 'check';
            },
            editEduCourseCharpterTestpaper(eduCourseCharpterTestpaperId) {
                console.log('eduCourseCharpterTestpaper', eduCourseCharpterTestpaperId);
                if (eduCourseCharpterTestpaperId) {
                    this.currentEduCourseCharpterTestpaperId = eduCourseCharpterTestpaperId;
                    this.getEduCourseCharpterTestpaperById();
                } else {
                    this.eduCourseCharpterTestpaper = { ...this.eduCourseCharpterTestpaper, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduCourseCharpterTestpaperState = 'edit';
            },
            deleteEduCourseCharpterTestpaper(eduCourseCharpterTestpaperId) {
                let ids = '';
                if (eduCourseCharpterTestpaperId) {
                    ids = eduCourseCharpterTestpaperId;
                } else {
                    ids = this.multipleSelection.map((eduCourseCharpterTestpaper) => eduCourseCharpterTestpaper.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/coursecharptertestpaper/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseCharpterTestpaperList();
                                this.getEduCourseCharpterTestpaperList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduCourseCharpterTestpaperList() {
                this.resetEduCourseCharpterTestpaperList();
                this.getEduCourseCharpterTestpaperList();
            },
            getEduCourseCharpterTestpaperList(query = {}) {
                this.loading = true;
                get(`/edu/coursecharptertestpaper/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduCourseCharpterTestpaperList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduCourseCharpterTestpaperById() {
                get(`/edu/coursecharptertestpaper/get`,{ id: this.currentEduCourseCharpterTestpaperId }).then((res) =>{
                    if(res.success){
                      this.eduCourseCharpterTestpaper = { ...this.eduCourseCharpterTestpaper, ...res.eduCourseCharpterTestpaper };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduCourseCharpterTestpaperList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/coursecharptertestpaper/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/coursecharptertestpaper/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/coursecharptertestpaper/importData`,formData);
              this.refreshEduCourseCharpterTestpaperList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduCourseCharpterTestpaperList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduCourseCharpterTestpaperList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>